import { render, staticRenderFns } from "./qa.vue?vue&type=template&id=1baa5d52&scoped=true"
import script from "./qa.vue?vue&type=script&lang=ts"
export * from "./qa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa5d52",
  null
  
)

export default component.exports